import { Button, InputField, Spacer } from '../../../../components/atoms';
import { Modal } from '../../../../components/molecules';
import { AdduserCon, InputCon, extraStylesInput } from './style';
import { useState } from 'react';
import { COMMONTYPES } from '../../../../TYPES/event.types';
import { useQueryClient } from 'react-query';
import { useMutationHook } from '../../../../network/mutations/useMutationHook';
import { addLogistics } from '../../../../network/services/admin/logistics';

type AddLogisticsProps = {
  onModalClose: () => void;
};

const INITIAL_STATE = {
  name: ''
};

export const AddLogistics = ({ onModalClose }: AddLogisticsProps) => {
  const [formData, setFormData] = useState(INITIAL_STATE);
  const queryClient = useQueryClient();

  const onInputChange = (e: COMMONTYPES['inputChange']) => {
    const { name, value } = e.target;
    setFormData(formData => ({ ...formData, [name]: value }));
  };

  const { mutateAsync, isLoading } = useMutationHook(addLogistics, 'ADD_LOGISTICS');

  const _AddLogistics = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    try {
      const { data } = await mutateAsync(formData);
      if (data.status === 'success') {
        queryClient.invalidateQueries('admin_logistics');
        onModalClose();
      }
    } catch (error: any) {}
  };

  const disabled = !formData.name;
  return (
    <Modal title="Add Logistics" maxWidth="500px" onModalClose={onModalClose}>
      <AdduserCon>
        <InputCon>
          <span>Name</span>
          <InputField extraStyles={extraStylesInput} onChange={onInputChange} name="name" />
        </InputCon>
        <Spacer height="22px" />

        <Spacer height="52px" />

        <Button onClick={_AddLogistics} isLoading={isLoading} disabled={disabled}>
          Add
        </Button>
      </AdduserCon>
    </Modal>
  );
};
